import { createSlice } from "@reduxjs/toolkit";

import { fetchPipelineFunnel } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load pipeline funnel";

const pipelineFunnelSlice = createSlice({
  name: "pipelineFunnel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipelineFunnel.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPipelineFunnel.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPipelineFunnel.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default pipelineFunnelSlice.reducer;
